const education = [
  {
    institution: {
      en: "Helwan University",
      ar: "جامعة حلوان",
    },
    degree: {
      en: "Bachelor of Computer Science",
      ar: "بكالوريوس الحاسبات والمعلومات",
    },
    location: {
      en: "Helwan, Cairo, Egypt",
      ar: "حلوان، القاهرة، مصر",
    },
    duration: {
      en: "2020 – 2024",
      ar: "2020 – 2024",
    },
    major: {
      en: "Computer Science",
      ar: "علوم الحاسب",
    },
    minor: {
      en: "Software Engineering",
      ar: "هندسة البرمجيات",
    },
    gpa: {
      en: "GPA: 2.84 (Very Good)",
      ar: "المعدل التراكمي: 2.84 (تقدير جيد جداً)",
    },
    logo: "hu.png",
  },
];

export default education;
